import CareServiceRequest from 'features/CareServiceRequest'

export default (props) => <CareServiceRequest {...{
  ...props,
  careOptionName: 'Telemedicine'
}} />
